module.exports = __webpack_public_path__ + "img/building-main.86bdd9de.jpeg";